const tables = [
  {
    name: "Number",
  },
  {
    name: "Date",
  },
  {
    name: "Description",
  },
  {
    name: "Category",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
